import { useState } from "react";
import { GroupListRow } from "../../../types";
import { ApiError, GroupApi } from "../api";
import { Button, Panel } from "./Shell";

// Pick which group survives; every other selected group is marked
// `mergedInto` it. Both records are kept, and it can be undone from the
// absorbed group's page.
export const MergeDialog = ({ groups, onClose, onDone }: { groups: GroupListRow[]; onClose: () => void; onDone: () => void }) => {
  const [survivor, setSurvivor] = useState(groups[0]?.id);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | undefined>();

  const merge = async () => {
    if (!survivor) return;
    setBusy(true);
    setError(undefined);
    try {
      for (const g of groups) {
        if (g.id === survivor) continue;
        await GroupApi.update({ id: g.id, mergedInto: survivor });
      }
      onDone();
    } catch (e) {
      setError(e instanceof ApiError ? e.message : "Merge failed");
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center p-4" onClick={onClose}>
      <Panel className="w-full max-w-lg p-4 space-y-3" >
        <div onClick={(e) => e.stopPropagation()} className="space-y-3">
          <h2 className="font-semibold">Combine {groups.length} groups</h2>
          <p className="text-sm text-neutral-500">Choose the group that stays in the list. The others are kept but shown under it; new matching events land on the survivor.</p>
          <div className="space-y-1">
            {groups.map((g) => (
              <label key={g.id} className="flex items-start gap-2 text-sm">
                <input type="radio" name="survivor" className="mt-1" checked={survivor === g.id} onChange={() => setSurvivor(g.id)} />
                <span className="min-w-0">
                  <span className="block truncate">{g.title}</span>
                  <span className="text-xs text-neutral-500">{g.source} · {g.totalCount} events</span>
                </span>
              </label>
            ))}
          </div>
          {error && <p className="text-sm text-red-600">{error}</p>}
          <div className="flex gap-2 justify-end">
            <Button onClick={onClose} disabled={busy}>Cancel</Button>
            <Button kind="primary" onClick={merge} disabled={busy || !survivor}>{busy ? "Combining…" : "Combine"}</Button>
          </div>
        </div>
      </Panel>
    </div>
  );
};
